module.exports = __webpack_public_path__ + "img/newsImg6-3.6891cfab.png";